import React from "react";
import { useDispatch } from "react-redux";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";
import {
  handleSendMaterials,
  isNumberKey,
  numberToCurrency,
} from "../../helpers";
import bin from "../../images/bin-grey.png";
import reorder from "../../images/reorder.png";
import { deleteMaterial, updateMaterial } from "../../store/entities/materials";

function MaterialsRow(props) {
  const dispatch = useDispatch();
  const { material, provided, index } = props;
  const { cost, quantity, materialId, description } = material;
  const total = cost * quantity;
  const formattedCost = numberToCurrency(total);

  function onChangeHandler(e) {
    const key = e.target.name;
    let value = e.target.value;
    if (key === "cost" || key === "quantity") {
      if (e.target.value) {
        value = parseInt(value.slice(-4));
      } else value = 0;
    }
    dispatch(
      updateMaterial({
        materialId,
        key,
        value,
      })
    );
  }

  function handleDeleteMaterial() {
    dispatch(deleteMaterial({ materialId }));
    handleSendMaterials();
  }

  return (
    <div className="row">
      <Tippy content="Drag to reorder rows">
        <div {...provided.dragHandleProps} className="hidden grabHandle">
          <img src={reorder} alt="reorder" />
        </div>
      </Tippy>
      <input
        id={index + "description"}
        name="description"
        value={description}
        onChange={onChangeHandler}
        onBlur={handleSendMaterials}
        className="field materialsDescription"
      />

      <div className="pound">
        <p>£</p>
        <input
          type="text"
          id={index + "cost"}
          name="cost"
          value={cost}
          onKeyDown={isNumberKey}
          onChange={onChangeHandler}
          onBlur={handleSendMaterials}
          className="field materialsCost"
        />
      </div>

      {/* <input
        type="text"
        id={index + "cost"}
        name="cost"
        value={cost}
        onKeyDown={isNumberKey}
        onChange={onChangeHandler}
        onBlur={handleSendMaterials}
        className="field materialsCost"
        // list={`${materialId}roleList`}
      /> */}
      <input
        id={index + "quantity"}
        name="quantity"
        value={quantity}
        onKeyDown={isNumberKey}
        onChange={onChangeHandler}
        onBlur={handleSendMaterials}
        className="field materialsQuantity"
      />
      <p className="field display materialsTotal">
        £{formattedCost ? formattedCost : 0}
      </p>
      <div className="hidden deleteIcon">
        <img
          src={bin}
          alt="delete"
          style={{ cursor: "pointer" }}
          onClick={handleDeleteMaterial}
        />
      </div>
    </div>
  );
}
export default MaterialsRow;
